import { render } from "./ItemGroupComponent.vue?vue&type=template&id=6d1831d0&scoped=true"
import script from "./ItemGroupComponent.vue?vue&type=script&lang=js"
export * from "./ItemGroupComponent.vue?vue&type=script&lang=js"

import "./ItemGroupComponent.vue?vue&type=style&index=0&id=6d1831d0&lang=scss"
import "./ItemGroupComponent.vue?vue&type=style&index=1&id=6d1831d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1831d0"]])

export default __exports__